export default __webpack_public_path__ + "static/media/shopify-section-6.5fa45739.jpg";